var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all:bg-white lg:bg-inherit all:p-0 all:pl-4 all:pb-4 lg:px-6 lg:pt-16"},[_c('CollapsibleNav',{attrs:{"nav":_vm.nav}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }